var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFromList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 15L9.375 13.6875L11.8125 11.25L9.375 8.8125L10.6875 7.5L13.125 9.9375L15.5625 7.5L16.875 8.8125L14.4375 11.25L16.875 13.6875L15.5625 15L13.125 12.5625L10.6875 15ZM0 9.375V7.5H6.5625V9.375H0ZM0 5.625V3.75H10.3125V5.625H0ZM0 1.875V0H10.3125V1.875H0Z",
    fill: "#004F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromList);
export default __webpack_public_path__ + "static/media/RemoveFromList.e94282023d515944525c04fe1d737aa4.svg";
export { ForwardRef as ReactComponent };